// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".holding-table-card-table{margin-top:16px}.holding-table-card-row:last-child{border:0 !important}.holding-table-card-row{border-bottom:solid 1px rgba(0,0,0,.1);padding:8px 0}.holding-table-card-row p{font-size:12px}.holding-table-card-row p a{text-decoration:none}", ""]);
// Exports
module.exports = exports;
